<style>
  .video-wrapper {
    aspect-ratio: 16/9;
    background: #1a1a1a;
    width: 100%;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 700ms cubic-bezier(0.25, 1, 0.5, 1);
  }

  .overlay {
    position: absolute;
    bottom: 1.5rem;
    left: 1.5rem;
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: white;
    mix-blend-mode: difference;
    pointer-events: none;
    opacity: 1;
    transition: opacity 300ms;
  }

  .video-wrapper.playing .overlay {
    opacity: 0;
  }

  .video-wrapper.playing video {
    cursor: default;
  }
</style>

<script>
  let { previewSrc, fullSrc, poster, onclick } = $props();

  let videoElement = $state(null);
  let isPlaying = $state(false);
  let duration = $state("04:27");

  function formatDuration(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }

  function handleLoadedMetadata() {
    if (videoElement && videoElement.duration) {
      // duration = formatDuration(videoElement.duration);
    }
  }

  function handleClick(e) {
    if (onclick) {
      onclick(e);
    } else if (!isPlaying && videoElement) {
      videoElement.src = fullSrc;
      videoElement.muted = false;
      videoElement.controls = true;
      videoElement.loop = false;
      videoElement.play();
      isPlaying = true;
    }
  }
</script>

<div class="video-wrapper" class:playing={isPlaying} onclick={handleClick}>
  <video
    bind:this={videoElement}
    src={previewSrc}
    {poster}
    autoplay
    muted
    loop
    playsinline
    onloadedmetadata={handleLoadedMetadata}
  >
  </video>
  <div class="overlay">Play Video [{duration}]</div>
</div>
